import {createSlice} from "@reduxjs/toolkit";

const sectionSlice = createSlice({
    name: "sectionRedux",
    initialState: {
        sections: []
    },
    reducers: {
        addSection: (state, action) => {
            state.sections.push(action.payload);
        },

        editSection: (state, action) => {
            const updatedSection = action.payload;
            for(const item of state.sections){
                if(item.sectionId === updatedSection.sectionId){
                    item.sectionName = updatedSection.sectionName;
                    item.sectionDesc = updatedSection.sectionDesc;
                    item.sectionHead = updatedSection.sectionHead;
                    break;
                }
            }
            
        },
        
    }
});

export const {addSection, editSection} = sectionSlice.actions;
export default sectionSlice.reducer;